import Divider from './src/divider.vue'
import { SFCWithInstall, withInstall } from '@touchvue/utils'
export const ToDivider: SFCWithInstall<typeof Divider> = withInstall(Divider)
export * from './src/instance'
